module.exports = __webpack_public_path__ + "img/default_platform.5b55a00e.png";